module.exports = __webpack_public_path__ + "static/SignUppng-a3a9064f658c49355de94b722187be14.png";